import React, { useState,useEffect,useRef } from "react";
import DatePicker from "react-datepicker";
import DesignationSelect from "../DesignationSelect";
import DepartmentSelect from "../DepartmentSelect";
import EmploymentStatusSelect from "../EmploymentStatusSelect";
import EmploymentTypeSelect from "../EmploymentTypeSelect";

import WorkPreferenceSelect from "../WorkPreferenceSelect";
import ShiftSelect from "../ShiftSelect";
import ReportingSelect from "../ReportingSelect";


const EmploymentInformationModal = ({ userData, onUpdate }) => {
  const submitButtonRef = useRef(null);


  const [editedData, setEditedData] = useState({
    ...userData,
   
  });

  useEffect(() => {

    setEditedData({
      ...userData,
      department: userData.department ? { value: userData.department, label: userData.department_name } : null,
      designation: userData.designation ? { value: userData.designation, label: userData.designation_name } : null,
      reportingto: userData.reportingto ? { value: userData.reportingto, label: userData.reporting_name } : null,
      employment_type: userData.employment_type ? { value: userData.employment_type, label: userData.employment_name } : null,
      empstatus: userData.empstatus ? { value: userData.empstatus, label: userData.empstatus_name } : null,
      work_preference: userData.work_preference ? { value: userData.work_preference, label: userData.work_preference_name } : null,
      shift: userData.shift ? { value: userData.shift, label: userData.shift_name } : null,
    });
  }, [userData]);

  const [errors, setErrors] = useState({});

  const employmentInfoDataL = [
    { id: 2, title: "Designation", name: "designation" },
    { id: 3, title: "Department", name: "department" },
    { id: 5, title: "Work Location", name: "work_location" },
    { id: 6, title: "Employment Type", name: "employment_type" },
    { id: 2, title: "Status", name: "empstatus" },
    { id: 1, title: "Work Preference.", name: "work_preference" },
    { id: 3, title: "Work Shift", name: "shift" },
    { id: 7, title: "Reporting to", name: "reportingto" },
  ];  

  const employmentInfoDataR = [
    { id: 1, title: "Employee ID",  name: "empcode"  },
    { id: 1, title: "Official Email", name: "email" },
    { id: 4, title: "CTC", name: "ctc" },
    { id: 5, title: "Work Phone", name: "work_phone" },
    { id: 4, title: "Date of Joining", name: "employee_doj" },
    { id: 4, title: "Date of Confirmation", name: "confirmation_date" }, // Corrected title
  ];

  const handleChange = (e) => {
    const { name, value } = e.target;
    setEditedData({ ...editedData, [name]: value });
  };

  const handleDesignationChange = (selectedOption) => {
    setEditedData({
      ...editedData,
      designation: selectedOption,
      designation_name: selectedOption ? selectedOption.label : "",
    });
  };

  const handleReportingtoChange = (selectedOption) => {
    setEditedData({
      ...editedData,
      reportingto: selectedOption,
      reporting_name: selectedOption ? selectedOption.label : "",
    });
  };

  const handleDepartmentChange = (selectedOption) => {
    setEditedData({
      ...editedData,
      department: selectedOption,
      department_name: selectedOption ? selectedOption.label : "",
    });
  };

  const handleEmploymentTypeChange = (selectedOption) => {
    setEditedData({
      ...editedData,
      employment_type: selectedOption,
    });
  };

  const handleEmploymentStatusChange = (selectedOption) => {
    setEditedData({
      ...editedData,
      empstatus: selectedOption,
    });
  };

  const handleEmploymentWpChange = (selectedOption) => {
    setEditedData({
      ...editedData,
      work_preference: selectedOption,
    });
  };

  const handleEmploymentShiftChange = (selectedOption) => {
    setEditedData({
      ...editedData,
      shift: selectedOption,
    });
  };

  const handleDateChange = (date, name) => {
    setEditedData({ ...editedData, [name]: date });
  };

  const handleValidation = () => {
    const requiredFields = ["empcode", "designation", "department"]; // Define required fields
    const isValid = requiredFields.every(field => editedData[field]); // Check if all required fields are filled
    return isValid;
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    if (handleValidation()) {

      onUpdate(editedData);

      
      if (submitButtonRef.current) {
        submitButtonRef.current.click(); // Trigger the click event
      }

    } else {
      console.log("Validation failed: Please fill in all required fields.");
    }
  };

  return (
    <div id="employment_info_modal" className="modal custom-modal fade" role="dialog">
      <form onSubmit={handleSubmit}>
        <div className="modal-dialog modal-lg" style={{ margin: 0, position: "fixed", right: 0, height: "calc(100% - 20px)", width: "60%" }}>
          <div className="modal-content" style={{ height: "100%" }}>
            <div className="modal-header">
              <h5 className="modal-title">Employment Information</h5>
              <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">×</span>
              </button>
            </div>
            <div className="modal-body" style={{ maxHeight: "calc(100% - 110px)", overflowY: "auto" }}>
              <div className="row">
                {/* Left Column */}  
                <div className="col-md-6">
                  {employmentInfoDataL.map((info) => (
                    <div key={info.id} className="input-block mb-3">
                      <label className="col-form-label">{info.title}</label>
                      {info.name === "designation" ? (
                        <DesignationSelect
                          name={info.name}
                          value={editedData[info.name] || null}
                          onChange={handleDesignationChange}
                        />
                      ) : info.name === "employment_type" ? (
                        <EmploymentTypeSelect
                          name={info.name}
                          value={editedData[info.name] || null}
                          onChange={handleEmploymentTypeChange}
                        />
                      ) : info.name === "department" ? (
                        <DepartmentSelect
                          name={info.name}
                          value={editedData[info.name] || null}
                          onChange={handleDepartmentChange}
                        />
                      ) : info.name === "empstatus" ? (
                        <EmploymentStatusSelect
                          name={info.name}
                          value={editedData[info.name] || null}
                          onChange={handleEmploymentStatusChange}
                        />
                      ) : info.name === "shift" ? (
                        <ShiftSelect
                          name={info.name}
                          value={editedData[info.name] || null}
                          onChange={handleEmploymentShiftChange}
                        />
                      ) : info.name === "work_preference" ? (
                        <WorkPreferenceSelect
                          name={info.name}
                          value={editedData[info.name] || null}
                          onChange={handleEmploymentWpChange}
                        />
                      ) : info.name === "reportingto" ? (
                        <ReportingSelect
                          name={info.name}
                          value={editedData[info.name] || null}
                          onChange={handleReportingtoChange}
                        />
                      ) : (
                        <input
                          type="text"
                          className="form-control"
                          name={info.name}
                          value={editedData[info.name] || ""}
                          onChange={handleChange}
                        />
                      )}
                    </div>
                  ))}
                </div>
                {/* Right Column */}
                <div className="col-md-6">
                  {employmentInfoDataR.map((info) => (
                    <div key={info.id} className="input-block mb-3">
                      <label className="col-form-label">{info.title}</label>
                      {info.name === "employee_doj" || info.name === "confirmation_date" ? (
                        <DatePicker
                          selected={editedData[info.name] ? new Date(editedData[info.name]) : null}
                          onChange={(date) => handleDateChange(date, info.name)}
                          className="form-control"
                        />
                      ) : (
                        <input
                          type="text"
                          className="form-control"
                          name={info.name}
                          value={editedData[info.name] || ""}
                          onChange={handleChange}
                        />
                      )}
                    </div>
                  ))}
                </div>
              </div>
            </div>
            <div className="modal-footer" style={{ position: "sticky", bottom: 10, display: "flex", justifyContent: "center", backgroundColor: "#fff" }}>
              <button className="btn btn-primary submit-btn" type="submit">
                Submit
              </button>
            </div>
          </div>
        </div>
      </form>
      <div style={{ display: 'none' }}>
                <button
                  ref={submitButtonRef}
                  data-bs-dismiss="modal"
                  aria-label="Close"
                  type="reset"
                >
                  Submit2
                </button>
              </div>
    </div>
  );
};

export default EmploymentInformationModal;
